
module.exports = {
  
  MarketCheckData: [
   {
       id:"1",
       name:"Current PBM",
       current_spend:64000,
       color: "black",
       categories: [
           {
               c_name:"RB30",
               claims_count:152,
               claim_cost:53011,
               percentage:50,
               rebates: 15,
           },
           {
               c_name:"MB30",
               claims_count:292,
               claim_cost:32115,
               percentage:60,
               rebates: 22,
           }
           ,
           {
               c_name:"MG30",
               claims_count:414,
               claim_cost:124124,
               percentage:83.2,
               rebates: 45,
           }
           ,
           {
               c_name:"RB90",
               claims_count:332,
               claim_cost:123124,
               percentage:22,
               rebates: 123,
           }
           ,
           {
               c_name:"MB90",
               claims_count:431,
               claim_cost:884134,
               percentage:77.2,
               rebates: 19,
           }
       ]
   }, {
       id:"2",
       name:"PBM Contract 1",
       current_spend:23100,
       color: "#3ba273",
       categories: [
         {
           c_name:"RB30",
           claims_count:931,
           claim_cost:34421,
           percentage:50,
           rebates: 84,
       },
       {
           c_name:"MB30",
           claims_count:123,
           claim_cost:43222,
           percentage:29,
           rebates: 89,
       }
       ,
       {
           c_name:"MG30",
           claims_count:152,
           claim_cost:322122,
           percentage:88,
           rebates: 35,
       }
       ,
       {
           c_name:"RB90",
           claims_count:992,
           claim_cost:443342,
           percentage:48,
           rebates: 55,
       }
       ,
       {
           c_name:"MB90",
           claims_count:773,
           claim_cost:84848,
           percentage:21,
           rebates: 55,
       }
       ]
   },
   {
     id:"3",
     name:"PBM Contract 2",
     current_spend:12022,
     color: "#3ba273",
     categories: [
       {
         c_name:"RB30",
         claims_count:93,
         claim_cost:21234,
         percentage:44,
         rebates: 64,
     },
     {
         c_name:"MB30",
         claims_count:152,
         claim_cost:50000,
         percentage:32,
         rebates: 82,
     }
     ,
     {
         c_name:"MG30",
         claims_count:54,
         claim_cost:9123123,
         percentage:46,
         rebates: 74,
     }
     ,
     {
         c_name:"RB90",
         claims_count:87,
         claim_cost:857332,
         percentage:64,
         rebates: 25,
     }
     ,
     {
         c_name:"MB90",
         claims_count:76,
         claim_cost:506123,
         percentage:74,
         rebates: 98,
     }
     ]
 },
 {
   id:"4",
   name:"PBM Contract 3",
   color: "red",
   current_spend:443122,
   categories: [
     {
       c_name:"RB30",
       claims_count:894,
       claim_cost:63481,
       percentage:36,
       rebates: 23,
   },
   {
       c_name:"MB30",
       claims_count:334,
       claim_cost:775838,
       percentage:23,
       rebates: 25,
   }
   ,
   {
       c_name:"MG30",
       claims_count:949,
       claim_cost:347122,
       percentage:33,
       rebates: 18,
   }
   ,
   {
       c_name:"RB90",
       claims_count:662,
       claim_cost:38712,
       percentage:73,
       rebates: 12,
   }
   ,
   {
       c_name:"MB90",
       claims_count:774,
       claim_cost:8834,
       percentage:20,
       rebates: 82,
   }
   ]
 },
 {
   id:"5",
   name:"PBM Contract 4",
   current_spend:90123,
   color: "#3ba273",
   categories: [
     {
       c_name:"RB30",
       claims_count:112,
       claim_cost:38991,
       percentage:27,
       rebates: 64,
   },
   {
       c_name:"MB30",
       claims_count:127,
       claim_cost:88543,
       percentage:89,
       rebates: 72,
   }
   ,
   {
       c_name:"MG30",
       claims_count:123,
       claim_cost:982933,
       percentage:99,
       rebates: 23,
   }
   ,
   {
       c_name:"RB90",
       claims_count:222,
       claim_cost:774373,
       percentage:77,
       rebates: 72,
   }
   ,
   {
       c_name:"MB90",
       claims_count:72,
       claim_cost:881727,
       percentage:72,
       rebates: 34,
   }
   ]
 },
 {
   id:"6",
   name:"PBM Contract 5",
   current_spend:87872,
   color: "#3ba273",
   categories: [
     {
       c_name:"RB30",
       claims_count:661,
       claim_cost:729399,
       percentage:93,
       rebates: 64,
   },
   {
       c_name:"MB30",
       claims_count:627,
       claim_cost:194994,
       percentage:39,
       rebates: 72,
   }
   ,
   {
       c_name:"MG30",
       claims_count:712,
       claim_cost:981239,
       percentage:65,
       rebates: 74,
   }
   ,
   {
       c_name:"RB90",
       claims_count:734,
       claim_cost:772399,
       percentage:34,
       rebates: 62,
   }
   ,
   {
       c_name:"MB90",
       claims_count:524,
       claim_cost:723621,
       percentage:45,
       rebates: 55,
   }
   ]
 }
 ]
  
 };
 
 
 